<aslib-title Text="Consulta/Índice de Participação do Município" SubText="Consultar" Icon="fa fa-dollar"></aslib-title>
<form novalidate [formGroup]='formIndiceMensal'>
  <div class="form-group row">
    <label for="" class="col-md-3 text-right">Ano:<span>*</span></label>
    <div class="controls col-md-3">
      <select [(ngModel)]="anoSelected"  formControlName="Ano" class="form-control" (change)="onChangeAno()" >
        <option [ngValue]=undefined>Selecione</option>
        <option *ngFor="let ano of listaAno" [ngValue]="ano">{{ano.Descricao}}</option>
      </select>
    </div>
  </div>

  <div class="form-group row">
    <label for="" class="col-md-3 text-right">Município:</label>
    <div class="controls col-md-3">
      <select [(ngModel)]="municipioSelected"  formControlName="Municipio" class="form-control" (change)="onChangeAno()">
        <option [ngValue]=undefined>Todos</option>
        <option *ngFor="let municipio of listaMunicipio" [ngValue]= "municipio">{{municipio.Descricao}}</option>
      </select>
    </div>
  </div>

  <div class="form-group row">
    <div class="controls col-md-9 offset-md-3">
      <button type="submit" class="btn btn-primary" [disabled]="!formIndiceMensal.valid" (click)="consultarIndiceParticipacaoMunicipio(modalMensagem)" >
        <aslib-icon type="1" icon="fa fa-check"></aslib-icon>Aplicar Filtro
      </button>
    </div>
  </div>
  
  <div class="form-group row mb-5" *ngIf="exibirGrid" >
    <aslib-grid id="as-grid" class="col-md-12" [(dataset)]="indiceParticipacaoMunicipioModelView.ListaIndiceMensalMunicpio" [pagination]="true">
      <aslib-grid-column [property]="'DescricaoMunicipio'" [header]="'Município'" [width]="300" [sortable]="true"></aslib-grid-column>

      <aslib-grid-column [property]="'ValorIndiceParticipacaoMunicipio'"  [width]="200" [header]="'Índice'"  [sortable]="true">
        <ng-template #AslibGridCell let-item="item">
          <span>{{ item.ValorIndiceParticipacaoMunicipio | trocarDeVirgulaParaPonto }}</span>
        </ng-template>
     </aslib-grid-column>

    </aslib-grid>
  </div>

<div class="form-group row"  *ngIf="exibirGrid" >
  <div class="col-md-12">
    <button type="submit" class="btn btn-primary" (click)="gerarRelatorio(0)" [disabled]="!formIndiceMensal.valid" >
      <aslib-icon type="1" icon="fa fa-check"></aslib-icon>Pdf
    </button>
    <button type="submit" class="btn btn-primary" (click)="gerarRelatorio(1)" [disabled]="!formIndiceMensal.valid" >
      <aslib-icon type="1" icon="fa fa-check"></aslib-icon>Excel
    </button>
  </div>
</div>

</form>
<aslib-modal #modalMensagem></aslib-modal>



// WEBPACK FOOTER //
// ./src/app/consulta/indice-participacao-municipio/indice-participacao-municipio.component.html